// extracted by mini-css-extract-plugin
module.exports = {"overlay":"NewsletterModal_overlay__PzHVc","modal":"NewsletterModal_modal__xZAiE","close":"NewsletterModal_close__xtxTg"};